import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import MarketplaceHero from './components/MarketplaceHero';
import HowItWorks from './components/HowItWorks';
import LiveJobFeed from './components/LiveJobFeed';
import BenefitsSection from './components/BenefitsSection';
import FinalCTA from './components/FinalCTA';
import BackToTop from '../../components/feature/BackToTop';
import { useEffect } from 'react';

export default function JobMarketplacePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <MarketplaceHero />
      <HowItWorks />
      <LiveJobFeed />
      <BenefitsSection />
      <FinalCTA />
      <Footer />
      <BackToTop />
    </div>
  );
}